import { LazyLoader } from '@bp/ui-components';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Page } from '../../../components/Page/Page';
import { SubstitutionsTopBar } from '../../../components/SubstitutionsTopBar/SubstitutionsTopBar';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

type PlanSubstitutionsProps = {
  baseSlug: string;
};

export const SubstitutionsPlanSubpage = ({ baseSlug }: PlanSubstitutionsProps) => {
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageSubstitution()}>
      <SubstitutionsTopBar baseSlug={baseSlug} />
      <Outlet />
    </Page>
  );
};
